import AddFerry from "../components/ferries/addFerry/addFerry";
import { UserRoles } from "../../helpers/userRoles";
import FerriesList from "../components/ferries/ferriesList/ferriesList";
import PortsList from "../components/ports/portsList/portsList";
import CompaniesList from "../components/companies/companiesList/companiesList";
import ShipownersList from "../components/shipowners/shipownersList/shipownersList";
import UnCodesList from "../components/unCodes/unCodesList/unCodesList";
import AddOwnedVehicle from "../components/dictionariesOwnedVehicles/addOwnedVehicle/addOwnedVehicle";
import DictionariesOwnedVehiclesList from "../components/dictionariesOwnedVehicles/dictionariesOwnedVehiclesList/dictionariesOwnedVehiclesList";
import AddPacking from "../components/packing/addPacking/addPacking";
import ModifyFerry from "../components/ferries/modifyFerry/modifyFerry";
import AddPort from "../components/ports/addPort/addPort";
import ModifyCompany from "../components/companies/modifyCompany/modifyCompany";
import AddCompany from "../components/companies/addCompany/addCompany";
import ModifyShipowner from "../components/shipowners/modifyShipowner/modifyShipowner";
import AddShipowner from "../components/shipowners/addShipowner/addShipowner";
import ModifyUnCode from "../components/unCodes/modifyUnCode/modifyUnCode";
import PackingList from "../components/packing/packingList/packingList";
import {RoutingModel} from "../../common/models/routing";
import RouteSwitch from "../../helpers/routeSwitch";
import ModifyPort from "../components/ports/modifyPort/modifyPort";
import ModifyOwnedVehicle from "../components/dictionariesOwnedVehicles/modifyOwnedVehicle/modifyOwnedVehicle";
import ModifyPacking from "../components/packing/modifyPacking/modifyPacking";
import AddUnCode from "../components/unCodes/addUnCode/addUnCode";

enum ferriesRoutingAddress {
    ferries = "/dictionaries/ferries",
    list = "/dictionaries/ferries/list",
    add = "/dictionaries/ferries/add-ferry",
    modify = "/dictionaries/ferries/modify-ferry"
}

enum portsRoutingAddress {
    ports = "/dictionaries/ports",
    list = "/dictionaries/ports/list",
    add = "/dictionaries/ports/add-ports",
    modify = "/dictionaries/ports/modify-port"
}

enum shipownersRoutingAddress {
    shipowners = "/dictionaries/shipowners",
    list = "/dictionaries/shipowners/list",
    add = "/dictionaries/shipowners/add-shipowner",
    modify = "/dictionaries/shipowners/modify-shipowner"
}

enum companiesRoutingAddress {
    companies = "/dictionaries/companies",
    list = "/dictionaries/companies/list",
    add = "/dictionaries/companies/add-company",
    modify = "/dictionaries/companies/modify-company"
}

enum unCodesRoutingAddress {
    unCodes = "/dictionaries/un-codes",
    list = "/dictionaries/un-codes/list",
    modify = "/dictionaries/un-codes/modify-uncode",
    add = "/dictionaries/un-codes/add-uncode"
}

enum dictionariesOwnedVehiclesRoutingAddress {
    ownedVehicles = "/dictionaries/owned-vehicles",
    list = "/dictionaries/owned-vehicles/list",
    add = "/dictionaries/owned-vehicles/add-owned-vehicle",
    modify = "/dictionaries/owned-vehicles/modify-owned-vehicle"
}

enum packingRoutingAddress {
    packing = "/dictionaries/packing",
    list = "/dictionaries/packing/list",
    add = "/dictionaries/packing/add-packing",
    modify = "/dictionaries/packing/modify-packing"
}

export const dictionariesRoutingAddress = {
    ferries: ferriesRoutingAddress,
    ports: portsRoutingAddress,
    shipowners: shipownersRoutingAddress,
    companies: companiesRoutingAddress,
    unCodes: unCodesRoutingAddress,
    ownedVehicles: dictionariesOwnedVehiclesRoutingAddress,
    packing: packingRoutingAddress
};

export const dictionariesRoutes: RoutingModel[] = [
    {
        path: dictionariesRoutingAddress.ferries.ferries,
        component: RouteSwitch,
        routes: [
            {
                path: dictionariesRoutingAddress.ferries.add,
                component: AddFerry,
                roles: [UserRoles.dictionariesViewAndModification]
            },
            {
                path: `${dictionariesRoutingAddress.ferries.modify}/:id`,
                component: ModifyFerry,
                roles: [UserRoles.dictionariesViewAndModification]
            },
            {
                path: dictionariesRoutingAddress.ferries.list,
                component: FerriesList,
                roles: [UserRoles.dictionariesViewAndModification]
            }
        ]
    },
    {
        path: dictionariesRoutingAddress.ports.ports,
        component: RouteSwitch,
        roles: [UserRoles.dictionariesViewAndModification],
        routes: [
            {
                path: dictionariesRoutingAddress.ports.list,
                component: PortsList,
                roles: [UserRoles.dictionariesViewAndModification]
            },
            {
                path: dictionariesRoutingAddress.ports.add,
                component: AddPort,
                roles: [UserRoles.dictionariesViewAndModification]
            },
            {
                path: `${dictionariesRoutingAddress.ports.modify}/:id`,
                component: ModifyPort,
                roles: [UserRoles.dictionariesViewAndModification]
            }
        ]
    },
    {
        path: dictionariesRoutingAddress.companies.companies,
        component: RouteSwitch,
        roles: [UserRoles.dictionariesViewAndModification],
        routes: [
            {
                path: dictionariesRoutingAddress.companies.list,
                component: CompaniesList,
                roles: [UserRoles.dictionariesViewAndModification]
            },
            {
                path: `${dictionariesRoutingAddress.companies.modify}/:id`,
                component: ModifyCompany,
                roles: [UserRoles.dictionariesViewAndModification]
            },
            {
                path: dictionariesRoutingAddress.companies.add,
                component: AddCompany,
                roles: [UserRoles.dictionariesViewAndModification]
            }
        ]
    },
    {
        path: dictionariesRoutingAddress.shipowners.shipowners,
        component: RouteSwitch,
        roles: [UserRoles.dictionariesViewAndModification],
        routes: [
            {
                path: dictionariesRoutingAddress.shipowners.list,
                component: ShipownersList,
                roles: [UserRoles.dictionariesViewAndModification]
            },
            {
                path: `${dictionariesRoutingAddress.shipowners.modify}/:id`,
                component: ModifyShipowner,
                roles: [UserRoles.dictionariesViewAndModification]
            },
            {
                path: dictionariesRoutingAddress.shipowners.add,
                component: AddShipowner,
                roles: [UserRoles.dictionariesViewAndModification]
            }
        ]
    }, {
        path: dictionariesRoutingAddress.unCodes.unCodes,
        component: RouteSwitch,
        roles: [UserRoles.dictionariesViewAndModification],
        routes: [
            {
                path: `${dictionariesRoutingAddress.unCodes.modify}/:id`,
                component: ModifyUnCode,
                roles: [UserRoles.dictionariesViewAndModification]
            },
            {
                path: dictionariesRoutingAddress.unCodes.list,
                component: UnCodesList,
                roles: [UserRoles.dictionariesViewAndModification]
            },
            {
                path: dictionariesRoutingAddress.unCodes.add,
                component: AddUnCode,
                roles: [UserRoles.dictionariesViewAndModification]
            }
        ]
    }, {
        path: dictionariesRoutingAddress.ownedVehicles.ownedVehicles,
        component: RouteSwitch,
        roles: [UserRoles.dictionariesViewAndModification],
        routes: [
            {
                path: dictionariesRoutingAddress.ownedVehicles.add,
                component: AddOwnedVehicle,
                roles: [UserRoles.dictionariesViewAndModification]
            },
            {
                path: dictionariesRoutingAddress.ownedVehicles.list,
                component: DictionariesOwnedVehiclesList,
                roles: [UserRoles.dictionariesViewAndModification]
            },
            {
                path: `${dictionariesRoutingAddress.ownedVehicles.modify}/:id`,
                component: ModifyOwnedVehicle,
                roles: [UserRoles.dictionariesViewAndModification]
            }
        ]
    },
    {
        path: dictionariesRoutingAddress.packing.packing,
        component: RouteSwitch,
        roles: [UserRoles.dictionariesViewAndModification],
        routes: [
            {
                path: dictionariesRoutingAddress.packing.add,
                component: AddPacking,
                roles: [UserRoles.dictionariesViewAndModification]
            },
            {
                path: dictionariesRoutingAddress.packing.list,
                component: PackingList,
                roles: [UserRoles.dictionariesViewAndModification]
            },
            {
                path: `${dictionariesRoutingAddress.packing.modify}/:id`,
                component: ModifyPacking,
                roles: [UserRoles.dictionariesViewAndModification]
            }
        ]
    }
];
